module.exports = __webpack_public_path__ + "static/media/favicon.761b336f.ico";